/* eslint-disable no-nested-ternary */
import React from "react";
import { SolicitationProps } from "../../../../../domain/models/solicitation.model";
import { StackModel } from "../../../../../domain/models/stacks";
import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form-factory";
import { fields } from "./fields";
import { CardContent, Wrapper } from "./styles";

type PageProps = {
  data: SolicitationProps | undefined;
  loading: boolean;
  stackList: StackModel[] | undefined;
};

const RequestCustomer = ({
  data,
  loading,
  stackList,
}: PageProps): JSX.Element => {
  if (loading) <>loading...</>;

  return (
    <Wrapper>
      <BackButtom text="Dados do cliente" />

      <CardContent>
        <FormFactory
          groups={fields(data, stackList)}
          enbaleCountGroup
          onSubmit={async (values, actions) => {
            try {
              // await handleSubmit(values, actions, setStep)
              actions.setSubmitting(false);
            } catch (error) {
              actions.setSubmitting(false);
            }
          }}
          button={{ submit: "Salvar", submitting: "Salvando...", hide: true }}
        />
      </CardContent>
    </Wrapper>
  );
};
export default RequestCustomer;
